import { render, staticRenderFns } from "./ReCheckbox.vue?vue&type=template&id=0e60d3e5&"
import script from "./ReCheckbox.vue?vue&type=script&lang=js&"
export * from "./ReCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports